export default __webpack_public_path__ + "static/media/img_post2_5.3990cf15.png";